<template>
     <div id="mySendyModal" class="overlay fade-in-overlay">
       <div class="sendyModal">
            <a href="javascript:void(0)" class="closebtn" v-on:click="closeSendyModal();">x</a>
                <div class="overlay-content">
                    <div class="content-image"><img src="static/assets/images/dwerve_follow.jpeg" alt=""></div>
                        <div class="sendyWrap">
                            <h2 class="follow-title">Subscribe to our newsletter!</h2>
                            <h4  class="follow-subtitle">Signup and back early for bonus rewards!</h4>
                            <Sendy></Sendy>
                        </div>
                </div>
        </div>
    </div>
</template>

<script>
import Sendy from "@/views/Home/Sendy.vue";
export default {
  data: function() {
    return {};
  },
  methods: {
    openSendyModal() {
      document.getElementById("mySendyModal").style.display = "flex";
    },
    closeSendyModal() {
      document.getElementById("mySendyModal").style.display = "none";

    },
   
    onScrollOpen(){
       var globalSelf = this;
      $(window).scroll(function() {

        function setCookie(cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
          var expires = "expires="+d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
          var name = cname + "=";
          var ca = document.cookie.split(';');
          for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }

        var self = this;
       var noPopup = getCookie("noPopup");

       if(noPopup == null || noPopup == "" && globalSelf.$route.path == "/"){
          if($(window).scrollTop() + $(window).height() > $(document).height() - 2000) {
            var popupCookie = getCookie("popupCookie");
            if(popupCookie == null || popupCookie == ""){
              document.getElementById("mySendyModal").style.display = "flex";
              setCookie("popupCookie", "popupCookie", 30);
            }
          }
       }

         
        });
    }
  },
  mounted() {
      this.onScrollOpen();
      if(window.location.pathname == "/subscribe"){
        document.getElementById("mySendyModal").style.display = "flex";
      }
  },
  components: {
      Sendy
  }
};
</script>

<style scoped>
iframe {
    width: 100%;
    height: 400px;
}
div#mySendyModal {
    display: none;
    position: fixed;
    z-index: 999999;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: .625em;
    overflow-x: hidden;
    transition: background-color .1s;
    background-color: transparent;
}
.sendyModal {
    margin: auto;
    position: relative;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    width: 45em;
    max-width: 100%;
    padding: 0;
    z-index: 9999;
    border: none;
    border-radius: .3125em;
    background: #fff;
    font-family: inherit;
    display: flex;
    font-size: 1rem;
}
a.closebtn {
    width: 30px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    text-transform: lowercase;
    height: 30px;
    background-color: #fff;
    border-radius: 100%;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.2);
    cursor: pointer;
    position: absolute;
    right: -10px;
    top: -10px;
    font-size: 17px;
    z-index: 9999;
    text-shadow: none;
    color: #000;
}
.fade-in.three {
  -webkit-animation-delay: 2.6s;
  -moz-animation-delay: 2.6s;
  animation-delay: 2.6s;
}

.fade-in {
  opacity: 0; /* make things invisible upon start */
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.follow::before,
.follow::after {
  position: absolute;
  content: "";
  transition: all 0.5s;
}
.follow {
  position: absolute;
  top: 93%;
  left: 51%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.follow-title{
    font-family: Digitalt;
    color: #595959;
    font-size: 28px;
    line-height: 1.2;
    text-shadow: none;
    text-align: left;
    letter-spacing: normal;
}
.follow-subtitle{
    font-family: Grandmaster;
    font-size: 16px;
    color: #595959;
    text-shadow: none;
    text-align: left;
    line-height: 1.4;
    text-transform: none;
}
.sendyWrap {
    width: 90%;
    margin: auto;
    padding-bottom: 15px;
}
.content-image img{
    position: relative;
    min-height: 250px;
    width: 100%;
    object-fit: cover;
}
@media only screen and (max-width: 500px) {
    div#mySendyModal {
           width: 100%;
    }
    .sendyModal {
        width: 100%;
    }
    .follow-title{
      font-size: 25px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Home/SendyModal.vue